import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import Actions from './actions';
var Types = Actions.Types;
var INITIAL_STATE = {
  isLoading: false,
  orders: [],
  retailProducts: [],
  cart: [],
  destructuredCart: {},
  isRetail: false,
  price: {},
  customerList: [],
  assigned: false,
  selectedOrder: {},
  savedPromos: []
};

var offlineReducer = function offlineReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Types.OFFLINE_ORDERS_REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.OFFLINE_ORDERS:
      {
        var orders = action.orders;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          orders: orders
        });
      }

    case Types.OFFLINE_SEARCH_REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.OFFLINE_SEARCH_RETAIL_PRODUCT:
      {
        var retailProducts = action.retailProducts;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          retailProducts: retailProducts
        });
      }

    case Types.OFFLINE_ADD_TO_CART:
      {
        var cart = action.cart;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          addedToCart: true,
          cart: cart === null || cart === void 0 ? void 0 : cart.CartLines
        });
      }

    case Types.CLOSE_ADD_TO:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          addedToCart: false
        });
      }

    case Types.OFFLINE_CART_REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.OFFLINE_CART_RESPONSE:
      {
        var _cart = action.cart,
            price = action.price,
            isRetail = action.isRetail,
            destructuredCart = action.destructuredCart;
        return _objectSpread(_objectSpread({}, state), {}, {
          cart: _cart,
          price: price,
          destructuredCart: destructuredCart,
          isRetail: isRetail,
          isLoading: false
        });
      }

    case Types.REQUEST_SHIPPING_MODES:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          getShippingModes: true
        });
      }

    case Types.RECIEVE_SHIPPING_MODES:
      {
        var shippingModes = action.shippingModes;
        console.log('Received shipping modes: ', shippingModes);
        return _objectSpread(_objectSpread({}, state), {}, {
          getShippingModes: false,
          shippingModes: shippingModes
        });
      }

    case Types.SET_SHIPPING_MODE:
      {
        var shippingMode = action.shippingMode;
        console.log('Store Shipping Mode: ', shippingMode, action);
        return _objectSpread(_objectSpread({}, state), {}, {
          shippingMode: shippingMode
        });
      }

    case Types.CLEAR_RETAIL_STATES:
      {
        var _retailProducts = action.retailProducts;
        return _objectSpread(_objectSpread({}, state), {}, {
          retailProducts: _retailProducts,
          addedToCart: false
        });
      }

    case Types.REQUEST_POST_TIP:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isPostingTip: true
        });
      }

    case Types.RECIEVE_POST_TIP:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isPostingTip: false
        });
      }

    case Types.RECIEVE_VALIDATE_CART:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          validateSuccess: true
        });
      }

    case Types.HIDE_VALIDATE_CART:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          validateSuccess: false
        });
      }

    case Types.REQUEST_SUBMIT_CART:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isSubmittingCart: true,
          validateSuccess: false
        });
      }

    case Types.RECIEVE_SUBMIT_CART:
      {
        var submitInfo = action.submitInfo,
            paymentInfo = action.paymentInfo;
        return _objectSpread(_objectSpread({}, state), {}, {
          checkoutSuccess: true,
          isSubmittingCart: false,
          submitInfo: submitInfo,
          paymentInfo: paymentInfo
        });
      }

    case Types.RESET_LOADING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isValidatingTimeWanted: false,
          isSendingPromoCode: false,
          isSubmittingCart: false
        });
      }

    case Types.CLOSE_CHECKOUT:
      {
        return _objectSpread({}, INITIAL_STATE);
      }

    case Types.SET_GO_TO_CHECKOUT:
      {
        var goToCheckout = action.goToCheckout;
        return _objectSpread(_objectSpread({}, state), {}, {
          goToCheckout: goToCheckout
        });
      }

    case Types.SET_OFFLINE_SELECTED_ORDER:
      {
        var selectedOrder = action.selectedOrder;
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedOrder: selectedOrder
        });
      }

    case Types.GET_CUSTOMER:
      {
        var custList = action.custList;
        return _objectSpread(_objectSpread({}, state), {}, {
          customerList: custList
        });
      }

    case Types.ASSIGN_CUST:
      {
        var assigned = action.assigned;
        return _objectSpread(_objectSpread({}, state), {}, {
          assigned: assigned,
          isLoading: false
        });
      }

    case Types.RESET_CUST_LIST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          customerList: []
        });
      }

    case Types.SET_LOADER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.REQUEST_PROMO_CODE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isSendingPromoCode: true
        });
      }

    case Types.RECIEVE_PROMO_CODE:
      {
        var newCode = action.newCode;
        var statePromo = Array.isArray(state.savedPromos) ? state.savedPromos : [];
        var savedPromos = [newCode].concat(_toConsumableArray(statePromo));
        return _objectSpread(_objectSpread({}, state), {}, {
          isSendingPromoCode: false,
          savedPromos: savedPromos
        });
      }

    case Types.REMOVE_PROMO_CODE:
      {
        var removeCode = action.removeCode;

        var _statePromo = Array.isArray(state.savedPromos) ? state.savedPromos : [];

        var _savedPromos = _statePromo.filter(function (e) {
          return e !== removeCode;
        });

        return _objectSpread(_objectSpread({}, state), {}, {
          isSendingPromoCode: false,
          savedPromos: _savedPromos
        });
      }

    default:
      {
        return state;
      }
  }
};

export default offlineReducer;